import { analysisCalendarToday, analysisDatePreset } from "./analysis-date-range";

/** Previous production day in the factory's local calendar. */
export function defaultAnalysisDateRange(now = new Date()) {
  return analysisDatePreset("yesterday", analysisCalendarToday(now));
}

/** Sample dataset contains exactly the 30 complete days before today. */
export function testAnalysisDateRange(now = new Date()) {
  const today = Date.parse(`${analysisCalendarToday(now)}T00:00:00Z`);
  return { dateFrom: new Date(today - 30 * 86_400_000).toISOString().slice(0, 10), dateTo: new Date(today - 86_400_000).toISOString().slice(0, 10) };
}
